import { Component, Input, OnDestroy } from '@angular/core';
import { VMEJobScreenSupplierInfoJob } from '../../../../interfaces/screen-specific/job-screen';
import { Subscription } from 'rxjs';
import { EventService, JobsService } from '../../../../services';
import { SupplierJobScreenSupplierInfoJob } from '../../../../interfaces/screen-specific/job-screen/supplier/supplier-job-screen-supplier-info-job';

@Component({
  selector: 'supplier-job-screen-supplier-info',
  templateUrl: './supplier-job-screen-supplier-info.component.html',
  styleUrls: [
    './supplier-job-screen-supplier-info.component.scss',
    '../../common/common-scss/job-screen-supplier-info-common.scss',
    '../../common/job-screen-common.scss',
  ],
})
export class SupplierJobScreenSupplierInfoComponent implements OnDestroy {
  private _jobId: number;
  organisationTypeId = 3; // Implied by virtue of being a Supplier screen
  loadingJob: boolean = false;
  job: SupplierJobScreenSupplierInfoJob;

  subscriptions: Subscription[] = [];

  @Input('jobId')
  set jobId(jobId: number) {
    this._jobId = jobId;
    this.initData();
  }

  get jobId(): number {
    return this._jobId;
  }

  constructor(private jobService: JobsService, private eventService: EventService) {
    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event: any) => {
        this.handleEvents(event);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }

  initData() {
    this.getJob(this.jobId);
  }

  getJob(jobId: number) {
    this.loadingJob = true;
    this.jobService
      .getForComponent(jobId, 'supplier-job-screen-supplier-info')
      .then((supplier: SupplierJobScreenSupplierInfoJob) => {
        this.job = supplier;
        this.loadingJob = false;
      });
  }

  private handleEvents(event: any) {
    if (event.event == 'refresh-job') {
      this.getJob(this.jobId);
    }
  }
}
